import React from 'react';
import SearchBar from './SearchBar';
import './HomeBanner.scss';

const HomeBanner = ({ heading, showSearchBar }) => (
	<div className="homeBanner">
		{showSearchBar ? (
			<div className="bannerContent">
				<h1 className="bannerHeading">{heading}</h1>

				<SearchBar />
			</div>
		) : (
			''
		)}
	</div>
);

export default HomeBanner;
